module.exports = __webpack_public_path__ + "img/graphic-6.ee055b72.png";